const ApiUrl = "https://tirupurjewellery.in/";
// const ApiUrl = "http://localhost";

export default ApiUrl;
